/**
 * @fileoverview gRPC-Web generated client stub for admpb
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_type_date_pb = require('../../google/type/date_pb.js')
const proto = {};
proto.admpb = require('./userguide_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.admpb.UserGuideServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.admpb.UserGuideServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.admpb.ReadUserGuideRequest,
 *   !proto.admpb.ReadUserGuideResponse>}
 */
const methodDescriptor_UserGuideService_ReadUserGuide = new grpc.web.MethodDescriptor(
  '/admpb.UserGuideService/ReadUserGuide',
  grpc.web.MethodType.UNARY,
  proto.admpb.ReadUserGuideRequest,
  proto.admpb.ReadUserGuideResponse,
  /**
   * @param {!proto.admpb.ReadUserGuideRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.ReadUserGuideResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.admpb.ReadUserGuideRequest,
 *   !proto.admpb.ReadUserGuideResponse>}
 */
const methodInfo_UserGuideService_ReadUserGuide = new grpc.web.AbstractClientBase.MethodInfo(
  proto.admpb.ReadUserGuideResponse,
  /**
   * @param {!proto.admpb.ReadUserGuideRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.ReadUserGuideResponse.deserializeBinary
);


/**
 * @param {!proto.admpb.ReadUserGuideRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.admpb.ReadUserGuideResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.admpb.ReadUserGuideResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.admpb.UserGuideServiceClient.prototype.readUserGuide =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/admpb.UserGuideService/ReadUserGuide',
      request,
      metadata || {},
      methodDescriptor_UserGuideService_ReadUserGuide,
      callback);
};


/**
 * @param {!proto.admpb.ReadUserGuideRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.admpb.ReadUserGuideResponse>}
 *     Promise that resolves to the response
 */
proto.admpb.UserGuideServicePromiseClient.prototype.readUserGuide =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/admpb.UserGuideService/ReadUserGuide',
      request,
      metadata || {},
      methodDescriptor_UserGuideService_ReadUserGuide);
};


module.exports = proto.admpb;

